import { AgentThreadTaskStatus } from "@/api";
import { RtcTask, threadStore } from "@/store/thread";
import { convertFilePathToUrl } from "@/util/convertFilePathToUrl";
import { useObserver } from "mobx-react-lite";

export interface ExportStatus {
  /** 结果文件 URL */
  resultUrl: string;
  /** 结果文件名 */
  resultFilename: string;
  /** 后端渲染任务 */
  renderTask?: RtcTask;
}

export function useExportStatus(): ExportStatus {
  return useObserver(() => {
    // 检测后端是否有正在进行的渲染任务
    const renderTask = threadStore.rtcTasks.find(
      (task) =>
        task.data.tool_type === "render_video" &&
        (task.status === AgentThreadTaskStatus.Pending ||
          task.status === AgentThreadTaskStatus.Running)
    );

    // 获取最终渲染结果文件路径
    const finalResultPath =
      threadStore.rawArtifacts?.["<Final Result Artifact>"]?.content || "";

    // 转换文件路径为可访问的 URL
    const resultUrl = convertFilePathToUrl(finalResultPath);

    // 生成下载文件名（基于 thread 标题）
    const title = threadStore.thread?.title?.trim();
    const resultFilename = `VidMuse_${title || "result"}_output.mp4`;

    return {
      resultUrl,
      resultFilename,
      renderTask,
    };
  });
}
